/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Objednávka ${i.ref} potvrzena!`
};

const da_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Ordre ${i.ref} bekræftet!`
};

const de_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Bestellung ${i.ref} bestätigt!`
};

const en_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Order ${i.ref} confirmed!`
};

const es_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `¡Pedido ${i.ref} confirmado!`
};

const fr_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Commande ${i.ref} confirmée !`
};

const hu_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Rendelés ${i.ref} megerősítve!`
};

const it_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Ordine ${i.ref} confermato!`
};

const nl_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Bestelling ${i.ref} bevestigd!`
};

const pl_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Zamówienie ${i.ref} potwierdzone!`
};

const pt_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Pedido ${i.ref} confirmado!`
};

const sv_checkout_success_title = /** @type {(inputs: { ref: NonNullable<unknown> }) => string} */ (i) => {
	return `Beställning ${i.ref} bekräftad!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ ref: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_success_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_success_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_success_title", locale)
	if (locale === "cs") return cs_checkout_success_title(inputs)
	if (locale === "da") return da_checkout_success_title(inputs)
	if (locale === "de") return de_checkout_success_title(inputs)
	if (locale === "en") return en_checkout_success_title(inputs)
	if (locale === "es") return es_checkout_success_title(inputs)
	if (locale === "fr") return fr_checkout_success_title(inputs)
	if (locale === "hu") return hu_checkout_success_title(inputs)
	if (locale === "it") return it_checkout_success_title(inputs)
	if (locale === "nl") return nl_checkout_success_title(inputs)
	if (locale === "pl") return pl_checkout_success_title(inputs)
	if (locale === "pt") return pt_checkout_success_title(inputs)
	return sv_checkout_success_title(inputs)
};
export { checkout_success_title as "checkout.success_title" }